<template>
  <div
    :class="[
      'relative overflow-hidden rounded-lg bg-white/10',
      pulse ? 'animate-pulse' : '',
      customClass,
    ]"
    :style="styleObject"
  />
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  width: {
    type: String,
    default: '',
  },
  height: {
    type: String,
    default: '',
  },
  customClass: {
    type: String,
    default: '',
  },
  pulse: {
    type: Boolean,
    default: true,
  },
});

const styleObject = computed(() => {
  const style = {};
  if (props.width) {
    style.width = props.width;
  }
  if (props.height) {
    style.height = props.height;
  }
  return style;
});
</script>
